import { SagaIterator } from 'redux-saga'
import { all, fork, put, call, select, takeEvery } from 'redux-saga/effects'

import {
  RESERVAS_ACTIONS_OPEN_LETTER,
  RESERVAS_ACTIONS_PROCESS_ESTADOS_FUTUROS,
  RESERVAS_ACTIONS_OPEN_MULTI_LETTER,
  RESERVAS_ACTIONS_PROCESS_CURRENT_PATH,
  RESERVAS_ACTIONS_SET_CURRENT_PATH,
} from './type'

import { RootState } from '../../store'

import { tipoReserva } from '@/common/constants/default'
import { notifications } from '@/common/helpers/notifications'
import { postActualizarEstadoFuturoReservas } from '@/common/helpers/reservasServices'
import { Action } from '@/common/interfaces/general'

function* prepararParametros(): SagaIterator {
  try {
    const { selected } = yield select(
      (state: RootState) => state.ReservasOperaciones,
    )
    const { changeDetalle } = yield select(
      (state: RootState) => state.ReservasDetalles,
    )
    const { tipo } = yield select((state: RootState) => state.ReservasActions)

    const newChangeDetalle = structuredClone(changeDetalle)
    const newSelected = structuredClone(selected)
    const newTipo = structuredClone(tipo)

    yield call(
      postActualizarEstadoFuturoReservas,
      newChangeDetalle,
      newTipo,
      newSelected.ReservaId,
    )
    if (tipo === tipoReserva.hotel) {
      yield put({ type: RESERVAS_ACTIONS_OPEN_LETTER, payload: true })
    }
    if (tipo === tipoReserva.alimento) {
      if (selected.ReservaId === undefined) {
        yield put({ type: RESERVAS_ACTIONS_OPEN_MULTI_LETTER, payload: true })
      } else {
        yield put({ type: RESERVAS_ACTIONS_OPEN_LETTER, payload: true })
      }
    }
  } catch (error) {
    notifications({ ex: error })
  }
}

function* processCurrentPath({ payload }: Action<string>): SagaIterator {
  const { reservasWizzard } = yield select(
    (state: RootState) => state.Catalogos,
  )
  const pathEstado = reservasWizzard.get(payload)

  // El catálogo puede no estar cargado aún (o el path no existir): no guardar undefined,
  // dejaría currentPathEstado sin estadosId y rompería los consumidores
  if (!pathEstado) {
    return
  }

  yield put({ type: RESERVAS_ACTIONS_SET_CURRENT_PATH, payload: pathEstado })
}

// watchers
function* watchPrepareParams(): Generator {
  yield takeEvery(RESERVAS_ACTIONS_PROCESS_ESTADOS_FUTUROS, prepararParametros)
}

function* watchSetEstadoCurrentPath(): Generator {
  yield takeEvery(RESERVAS_ACTIONS_PROCESS_CURRENT_PATH, processCurrentPath)
}

export default function* reservasActionsSagas(): Generator {
  yield all([fork(watchPrepareParams), fork(watchSetEstadoCurrentPath)])
}
